import { useState, useCallback } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

interface ApiResponse {
  success: boolean;
  data?: any[];
  error?: string;
}

export const useRadSites = () => {
  const [data, setData] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRadSites = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<ApiResponse>(API_CONFIG.ENDPOINTS.GET_RAD_SITES);
      console.log('RAD Sites API Response:', response.data);
      
      // Handle nested response structure like other APIs
      let responseData = response.data;
      if (response.data.data && typeof response.data.data === 'object' && 'statusCode' in response.data.data) {
        responseData = JSON.parse((response.data.data as any).body);
      }
      
      console.log('Parsed RAD Sites Data:', responseData);
      
      if (responseData.success && Array.isArray(responseData.data)) {
        const sites = responseData.data.map((item: any) => {
          // Try different possible field names
          return item.organization_name || item.ORGANIZATION_NAME || item.organizationName || Object.values(item)[0];
        }).filter(Boolean);
        console.log('Extracted sites:', sites);
        setData(sites);
      } else {
        throw new Error(responseData.error || 'Failed to fetch RAD sites');
      }
    } catch (err: any) {
      console.error('RAD Sites Error:', err);
      setError(err.message || 'Error fetching RAD sites');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    error,
    fetchRadSites
  };
};